import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './LoginRecommendationModal.css';

const LoginRecommendationModal = ({ isVisible, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLoginClick = () => {
    onClose();
    navigate('/signin');
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div className="restaurant-login-overlay" onClick={handleOverlayClick}>
      <div className="restaurant-login-backdrop"></div>
      <div className="restaurant-login-modal">
        <button className="restaurant-login-close" onClick={onClose} aria-label="Close modal">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <div className="restaurant-login-content">
          <div className="restaurant-login-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2Z" fill="currentColor"/>
              <path d="M12 7C8.69 7 6 9.69 6 13V16H4V18H20V16H18V13C18 9.69 15.31 7 12 7Z" fill="currentColor"/>
              <circle cx="12" cy="20" r="2" fill="currentColor"/>
            </svg>
          </div>
          
          <div className="restaurant-login-divider">
            <div className="restaurant-login-spoon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 2C15.5 2 18 4.5 18 7.5C18 9.5 17 11.3 15.4 12.4L14.8 22H10.2L9.6 12.4C8 11.3 7 9.5 7 7.5C7 4.5 9.5 2 12.5 2Z" fill="currentColor"/>
              </svg>
            </div>
          </div>
          
          <h2 className="restaurant-login-title">
            {t('login_recommendation.title') || 'Join Our Culinary Journey'}
          </h2>
          
          <p className="restaurant-login-subtitle">
            {t('login_recommendation.subtitle') || 'Unlock exclusive dining experiences, personalized recommendations, and special member privileges at our restaurant.'}
          </p>
          
          <div className="restaurant-login-buttons">
            <button className="restaurant-login-primary-btn" onClick={handleLoginClick}>
              <span className="btn-text">{t('login_recommendation.login_button') || 'Sign In'}</span>
              <svg className="btn-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            
            <button className="restaurant-login-secondary-btn" onClick={onClose}>
              {t('login_recommendation.maybe_later') || 'Continue as Guest'}
            </button>
          </div>
        </div>
        
        <div className="restaurant-login-decoration">
          <div className="decoration-ornament decoration-ornament-1"></div>
          <div className="decoration-ornament decoration-ornament-2"></div>
          <div className="decoration-particle decoration-particle-1"></div>
          <div className="decoration-particle decoration-particle-2"></div>
          <div className="decoration-particle decoration-particle-3"></div>
        </div>
      </div>
    </div>
  );
};

export default LoginRecommendationModal;